<app-overlay-spinner *ngIf="networkService.offlineOrLoading || !groups"></app-overlay-spinner>

<div class="filter" style="display:flex; align-items:flex-end; justify-content:space-between; flex-wrap:wrap; gap:12px;">
  <div class="filters-row" style="display:flex; gap:12px; flex-wrap:wrap; align-items:flex-end;">
        <mat-form-field appearance="fill" style="width:180px;">
            <mat-label>{{ 'SENSORSTATION.NAME' | translate }}</mat-label>
            <input matInput [(ngModel)]="filters.name" (ngModelChange)="onFilterChange()" />
        </mat-form-field>
        <mat-form-field appearance="fill" style="width:160px;">
            <mat-label>{{ 'SENSORSTATION.ID' | translate }}</mat-label>
            <input matInput [(ngModel)]="filters.deviceId" (ngModelChange)="onFilterChange()" />
        </mat-form-field>
        <mat-form-field appearance="fill" style="width:180px;">
            <mat-label>{{ 'SENSORSTATION.GROUPNAME' | translate }}</mat-label>
            <input matInput [(ngModel)]="filters.group" (ngModelChange)="onFilterChange()" />
        </mat-form-field>
        <mat-form-field appearance="fill" style="width:180px;">
            <mat-label>{{ 'SENSORSTATION.STREET' | translate }}</mat-label>
            <input matInput [(ngModel)]="filters.street" (ngModelChange)="onFilterChange()" />
        </mat-form-field>
        <mat-form-field appearance="fill" style="width:160px;">
            <mat-label>{{ 'SENSORSTATION.CITY' | translate }}</mat-label>
            <input matInput [(ngModel)]="filters.city" (ngModelChange)="onFilterChange()" />
        </mat-form-field>
        <button mat-raised-button (click)="clearFilters()">{{ 'CLEARFILTER' | translate }}</button>
    </div>
  <ng-container *ngIf="authService.isSensorstationAdmin()">
    <button mat-raised-button color="primary" (click)="create()">
      {{ 'SENSORSTATION.TITLECREATE' | translate }}
    </button>
  </ng-container>
</div>

<table
        mat-table
        matSort
        [dataSource]="pagedSensorstations"
        class="mat-elevation-z8 sensorstations-table"
        multiTemplateDataRows="true"
        matSortActive="name"
        matSortDirection="asc"
        matSortStart="asc"
        (matSortChange)="onSortChange($event)"
>

    <ng-container matColumnDef="sensorstationName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="name">
            {{ 'SENSORSTATION.NAME' | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
            <span>{{ row.name }}</span>
        </td>
    </ng-container>

    <ng-container matColumnDef="sensorstationId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="deviceId">
            {{ 'SENSORSTATION.ID' | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
            <span *ngIf="row.deviceId">{{ row.deviceId }}</span>
        </td>
    </ng-container>

    <ng-container matColumnDef="sensorstationGroup">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="group">
            {{ 'SENSORSTATION.GROUPNAME' | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
            <span *ngIf="row.group">{{ row.group }}</span>
        </td>
    </ng-container>

    <ng-container matColumnDef="streetName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="street">
            {{ 'SENSORSTATION.STREET' | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
      <span *ngIf="row.location.street">
        {{ row.location.street }} <span *ngIf="row.location.houseNumber"> {{ row.location.houseNumber }} </span>
      </span>
        </td>
    </ng-container>

    <ng-container matColumnDef="cityName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="city">
            {{ 'SENSORSTATION.CITY' | translate }}
        </th>
        <td mat-cell *matCellDef="let row">
            <span *ngIf="row.location.city">{{ row.location.city }}</span>
        </td>
    </ng-container>

    <ng-container matColumnDef="details">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row" class="details">
            <div class="editButtons" *ngIf="authService.isSensorstationAdmin() || (authService.isSensorstationEditor() && isOwner(row))">
                <button mat-icon-button (click)="openEdit(row, true, $event)" matTooltip="Sensorstation bearbeiten">
                    <mat-icon>settings</mat-icon>
                </button>
                <button mat-icon-button (click)="deleteSensorstation(row, $event)" matTooltip="Sensorstation löschen">
                    <mat-icon>delete</mat-icon>
                </button>
                <button mat-icon-button (click)="showDetails(row)" matTooltip="Weitere Informationen zur Sensorstation">
                    <mat-icon>info</mat-icon>
                </button>
                <button mat-icon-button (click)="openDownloadsDialog(row, $event)" matTooltip="Downloads anzeigen">
                    <mat-icon>download</mat-icon>
                </button>
            </div>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="data-row">
    </tr>

</table>

<ng-template #downloadsDialog let-data let-dialogRef="dialogRef">
  <h2 mat-dialog-title>{{ data.row?.name || data.row?.deviceId }}</h2>
  <mat-dialog-content>
    <div class="download-filters">
      <div class="row">
          <mat-form-field appearance="fill">
              <mat-label>{{ 'SENSORSTATION.AGGREGATION_TIME' | translate }}</mat-label>
              <mat-select
                      [(value)]="downloadOptions.aggregationTime"
                      [disabled]="aggregationSelectionDisabled">

                  <!-- HOURLY ist immer verfügbar -->
                  <mat-option value="SENSORSTATION.HOURLY">{{ 'SENSORSTATION.HOURLY' | translate }}</mat-option>

                  <!-- Weitere Optionen nur für T-Systems -->
                  <ng-container *ngIf="allowAggregationSelectionFor(currentDownloadRow)">
                      <mat-option value="SENSORSTATION.DAILY">{{ 'SENSORSTATION.DAILY' | translate }}</mat-option>
                      <mat-option value="SENSORSTATION.MONTHLY">{{ 'SENSORSTATION.MONTHLY' | translate }}</mat-option>
                      <mat-option value="SENSORSTATION.FINEST">{{ 'SENSORSTATION.FINEST' | translate }}</mat-option>
                  </ng-container>
              </mat-select>
          </mat-form-field>

          <mat-form-field appearance="fill">
              <mat-label>{{ 'SENSORSTATION.FROM_DATE' | translate }}</mat-label>
              <input matInput [matDatepicker]="fromPicker"
                     [(ngModel)]="fromDate"
                     name="fromDate" />
              <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
              <mat-datepicker #fromPicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="fill">
              <mat-label>{{ 'SENSORSTATION.FROM_TIME' | translate }}</mat-label>
              <input matInput type="time"
                     [(ngModel)]="fromTime"
                     name="fromTime" />
          </mat-form-field>

          <mat-form-field appearance="fill">
              <mat-label>{{ 'SENSORSTATION.TO_DATE' | translate }}</mat-label>
              <input matInput [matDatepicker]="toPicker"
                     [(ngModel)]="toDate"
                     name="toDate" />
              <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
              <mat-datepicker #toPicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="fill">
              <mat-label>{{ 'SENSORSTATION.TO_TIME' | translate }}</mat-label>
              <input matInput type="time"
                     [(ngModel)]="toTime"
                     name="toTime" />
          </mat-form-field>
      </div>

      <div class="values">
        <div class="values-title">{{ 'SENSORSTATION.SELECT_VALUES' | translate }}</div>
        <div class="values-grid">
          <mat-checkbox [(ngModel)]="downloadOptions.valuesMap.NO" [disabled]="!allowFieldSelectionFor(currentDownloadRow)">NO</mat-checkbox>
          <mat-checkbox [(ngModel)]="downloadOptions.valuesMap.NO2" [disabled]="!allowFieldSelectionFor(currentDownloadRow)">NO2</mat-checkbox>
          <mat-checkbox [(ngModel)]="downloadOptions.valuesMap.O3" [disabled]="!allowFieldSelectionFor(currentDownloadRow)">O3</mat-checkbox>
          <mat-checkbox [(ngModel)]="downloadOptions.valuesMap.PM1" [disabled]="!allowFieldSelectionFor(currentDownloadRow)">PM1</mat-checkbox>
          <mat-checkbox [(ngModel)]="downloadOptions.valuesMap.PM25" [disabled]="!allowFieldSelectionFor(currentDownloadRow)">PM25</mat-checkbox>
          <mat-checkbox [(ngModel)]="downloadOptions.valuesMap.PM10" [disabled]="!allowFieldSelectionFor(currentDownloadRow)">PM10</mat-checkbox>
          <mat-checkbox [(ngModel)]="downloadOptions.valuesMap.ALL_FIELDS">{{ 'SENSORSTATION.ALL_FIELDS' | translate }}</mat-checkbox>
        </div>
      </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <div mat-dialog-actions [ngClass]="{ 'sensorstation-buttons': authService.isSensorstationMember() }">
    <button mat-raised-button  mat-dialog-close>{{ 'CLOSE' | translate }}</button>
    <button mat-raised-button color="primary" (click)="startDownloadWithOptions(data.row)" [disabled]="!isDownloadFormComplete()" mat-dialog-close>
        <mat-icon>download</mat-icon>
        {{ 'DOWNLOAD' | translate }}
    </button>
    </div>
</mat-dialog-actions>
</ng-template>

<mat-paginator
        [length]="totalItems"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [pageSizeOptions]="[10, 15, 30, 100]"
        (page)="onPageChange($event)">
</mat-paginator>